import { PageTitle } from "../../components/Headers";
import { PageBody } from "../../components/PageBody";
import { Helmet } from "react-helmet-async";
import { GridDiv, GridDivContainer } from "../../components/GridDiv";
import { ProjectLink } from "../../components/ProjectLink";
import { ArticleParagraph } from "../../components/Paragraphs";
import { getProjectsForSection } from "../../config/projects";
import { getSEOForPath } from "../../config/seo";
import { useLocation } from "react-router-dom";

// Get betting projects from centralized config
const bettingProjects = getProjectsForSection('/betting');


export const BettingHome = () => {
    const location = useLocation();
    const seo = getSEOForPath(location.pathname);
    
    return (
        <PageBody>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description}></meta>
                {seo.keywords && <meta name="keywords" content={seo.keywords}></meta>}
                {seo.canonical && <link rel="canonical" href={seo.canonical} />}
            </Helmet>

            <PageTitle title="Sports Betting" />

            <ArticleParagraph
                lines={[
                    "Sports betting seems simple, and it is made simple by bookmakers to encourage betting. Sports betting can be fun, but it is also addictive and should be consumed in moderation with a knowledge of the system.",
                    "Below are some articles and interactive pages that outline how sports betting works, and how you can find value in some bets. In understanding the system you can improve your judgement on the risk that you are taking, but remember that the risk is always there.",
                    "These resources are to inform and teach, and are not financial advice; please gamble responsibly and within your own limits by managing your risk and bank."
                ]}
            />

            <GridDivContainer>
                {bettingProjects.map((project) => (
                    <GridDiv
                        key={project.to}
                        widthClasses="w-full md:w-1/2"
                    >
                        <ProjectLink
                            to={project.to}
                            title={project.title}
                            icon={project.icon}
                            colorClass={project.colorClass}
                        />
                    </GridDiv>
                ))}
            </GridDivContainer>
        </PageBody>
    );
};
